import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export interface PageFAQItem {
  id: string;
  question: string;
  answer: string;
}

interface PageFAQProps {
  title?: string;
  subtitle?: string;
  items: PageFAQItem[];
}

export default function PageFAQ({
  title = 'Frequently Asked Questions',
  subtitle,
  items,
}: PageFAQProps) {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
            {title}
          </h2>
          {subtitle && <p className="text-muted-foreground max-w-3xl mx-auto">{subtitle}</p>}
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {items.map(item => (
            <div key={item.id} className="border border-border rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-muted/50 transition-colors"
              >
                <span className="font-heading font-semibold text-foreground pr-4">
                  {item.question}
                </span>
                <ChevronDown
                  className={`h-5 w-5 text-secondary flex-shrink-0 transition-transform duration-300 ${
                    openId === item.id ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-6 pb-6 text-muted-foreground leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
